import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useChartWorkbenchThemeOptional } from '../../chart-workbench/lib/chartWorkbenchTheme';

const readPageIsDark = () => typeof document !== 'undefined' && document.documentElement.getAttribute('data-bs-theme') === 'dark';

/** 业务统计图表：工作台壳内跟壳主题（已与 App 主题同步），否则直接跟 AppProvider / data-bs-theme */
export const useStatisticsChartTheme = () => {
	const reduxIsDark = useSelector((state) => state.config?.isDark);
	const workbenchTheme = useChartWorkbenchThemeOptional();
	const isDark = workbenchTheme ? workbenchTheme.theme === 'dark' : reduxIsDark ?? readPageIsDark();

	return useMemo(
		() => ({
			isDark,
			isLight: !isDark,
		}),
		[isDark],
	);
};

export default useStatisticsChartTheme;
